/* PetPouch: one delegated listener set survives Shopify section replacement. */
(() => {
  'use strict';
  if (window.pouchTheme) return;
  class PouchTheme {
    constructor() {
      this.products = new WeakMap();
      this.cartBusy = false;
      document.addEventListener('click', (event) => this.onClick(event));
      document.addEventListener('change', (event) => this.onChange(event));
      document.addEventListener('submit', (event) => this.onSubmit(event));
      document.addEventListener('keydown', (event) => this.onKeydown(event));
      document.addEventListener('shopify:section:load', () => this.init());
      document.addEventListener('shopify:section:unload', (event) => {
        event.target.querySelectorAll('[data-product-root]').forEach((root) => this.products.get(root)?.observer?.disconnect());
        event.target.querySelector('[data-size-chart][open]')?.close();
      });
      this.init();
      this.timer = window.setInterval(() => this.updateCountdowns(), 1000);
      window.addEventListener('scroll', () => this.updateSticky(), { passive: true });
    }

    cartUrl() { return window.routes?.cart_url || '/cart'; }
    money(cents, currency = 'PLN') {
      return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', { style: 'currency', currency }).format(Number(cents) / 100);
    }
    init() {
      document.querySelectorAll('[data-product-root]').forEach((root) => {
        if (this.products.has(root)) return;
        const form = root.querySelector('[data-product-form]');
        const data = root.querySelector('[data-product-json]');
        if (!form || !data) return;
        try {
          const product = JSON.parse(data.textContent);
          if (!Array.isArray(product.variants)) return;
          this.products.set(root, { product, form, busy: false, variant: null });
          const nativeVariant = root.querySelector('[data-native-variant]');
          if (nativeVariant) nativeVariant.hidden = true;
          const singleOptions = root.querySelector('[data-single-options]');
          if (singleOptions) singleOptions.hidden = false;
          this.initSizeChart(root);
          this.updateVariant(root, false);
        } catch (error) { console.warn('Nie udało się wczytać wariantów produktu.', error); }
      });
      this.updateCountdowns();
      this.updateSticky();
    }

    updateVariant(root, updateUrl) {
      const state = this.products.get(root);
      if (!state) return;
      const { form, product } = state;
      const variantInput = form.querySelector('[name="id"]');
      const options = [...root.querySelectorAll('[data-option-select]')].map((input) => input.value);
      const variant = options.length ? product.variants.find((item) => item.options.every((option, index) => String(option) === options[index])) : product.variants.find((item) => String(item.id) === variantInput.value) || product.variants[0];
      state.variant = variant || null;
      const available = Boolean(variant?.available);
      const sale = Boolean(variant && variant.compare_at_price > variant.price);
      root.dataset.onSale = String(sale);
      const label = variant ? (available ? product.labels.add : product.labels.soldOut) : product.labels.unavailable;
      variantInput.value = variant?.id || '';
      variantInput.disabled = !variant;
      const button = form.querySelector('[name="add"]');
      if (button) button.disabled = !available || state.busy;
      const buttonLabel = button?.querySelector('[data-add-label]');
      if (buttonLabel) buttonLabel.textContent = state.busy ? 'Dodawanie…' : label;
      const stickyButton = root.querySelector('[data-sticky-buy]');
      if (stickyButton) { stickyButton.disabled = !available || state.busy; stickyButton.textContent = state.busy ? 'Dodawanie…' : label; }
      const dynamic = root.querySelector('[data-dynamic-checkout]');
      if (dynamic) dynamic.hidden = !available;
      const price = root.querySelector('[data-product-price]');
      if (price) {
        price.replaceChildren();
        if (variant) {
          const current = document.createElement('span');
          current.className = sale ? 'price price--sale' : 'price';
          current.textContent = this.money(variant.price, product.currency);
          if (sale) { const compare = document.createElement('s'); compare.textContent = this.money(variant.compare_at_price, product.currency); current.append(' ', compare); }
          price.append(current);
        }
      }
      const saving = root.querySelector('[data-saving-message]');
      if (saving) saving.hidden = !sale;
      const savingAmount = root.querySelector('[data-saving-amount]');
      if (sale && savingAmount) savingAmount.textContent = this.money(variant.compare_at_price - variant.price, product.currency);
      const lowest = root.querySelector('[data-lowest-price]');
      if (lowest) lowest.hidden = !sale;
      const lowStock = available && Boolean(variant.inventory_management) && variant.inventory_policy === 'deny' && variant.inventory_quantity > 0 && variant.inventory_quantity <= Number(root.dataset.stockThreshold || 5);
      const stock = root.querySelector('[data-stock-message]');
      if (stock) stock.hidden = !lowStock;
      const stockCount = root.querySelector('[data-stock-count]');
      if (stockCount) stockCount.textContent = variant?.inventory_quantity || 0;
      const stickyPrice = root.querySelector('.sticky-atc__text small');
      if (stickyPrice) stickyPrice.textContent = variant ? this.money(variant.price, product.currency) : '';
      if (variant?.featured_image_url) {
        this.showMedia(root, String(variant.featured_media_id || ''), variant.featured_image_url, variant.featured_image_alt);
        const stickyImage = root.querySelector('.sticky-atc__product img');
        if (stickyImage) { stickyImage.src = variant.featured_image_url; stickyImage.removeAttribute('srcset'); }
      }
      if (updateUrl && root.dataset.updateUrl === 'true' && variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      this.updateCountdowns(root);
      this.updateBundles(root);
    }

    initSizeChart(root) {
      const dialog = root.querySelector('[data-size-chart]');
      if (!dialog || dialog.dataset.ready === 'true') return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('pp-dialog-open');
        root.querySelector('[data-size-chart-open]')?.focus();
      });
    }

    bundleRowVariant(row, product) {
      const options = [...row.querySelectorAll('[data-bundle-option]')].map((input) => input.value);
      return options.length ? product.variants.find((variant) => variant.options.every((option, index) => String(option) === options[index])) : product.variants[0];
    }

    syncBundleFirstRow(root, toMain = true) {
      const selected = root.querySelector('[data-bundle-choice]:checked')?.closest('[data-bundle-card]');
      if (!selected) return;
      const firstOptions = [...selected.querySelector('[data-bundle-row]').querySelectorAll('[data-bundle-option]')];
      const mainOptions = [...root.querySelectorAll('[data-option-select]')];
      firstOptions.forEach((option, index) => {
        if (mainOptions[index]) {
          if (toMain) mainOptions[index].value = option.value;
          else option.value = mainOptions[index].value;
        }
      });
    }

    updateBundles(root) {
      const picker = root.querySelector('[data-bundle-picker]');
      const state = this.products.get(root);
      if (!picker || !state) return;
      picker.hidden = false;
      const singleOptions = root.querySelector('[data-single-options]');
      if (singleOptions) singleOptions.hidden = true;
      const singleQuantity = root.querySelector('[data-quantity]');
      if (singleQuantity) singleQuantity.hidden = true;
      const checked = picker.querySelector('[data-bundle-choice]:checked');
      const activeCount = Number(checked?.value || 1);
      let activeBundle;
      picker.querySelectorAll('[data-bundle-card]').forEach((card) => {
        const active = Number(card.dataset.bundleCount) === activeCount;
        card.classList.toggle('is-selected', active);
        card.querySelector('[data-bundle-options]').hidden = !active;
        card.querySelector('[data-bundle-choice]').disabled = state.busy;
        card.querySelectorAll('[data-bundle-option]').forEach((select) => { select.disabled = !active || state.busy; });
        const rows = [...card.querySelectorAll('[data-bundle-row]')];
        const variants = rows.map((row) => this.bundleRowVariant(row, state.product));
        const counts = new Map();
        variants.forEach((variant) => { if (variant) counts.set(variant.id, (counts.get(variant.id) || 0) + 1); });
        let available = true;
        variants.forEach((variant, index) => {
          let message = '';
          if (!variant) message = 'Takie połączenie wariantów jest niedostępne.';
          else if (!variant.available) message = 'Ten wariant jest wyprzedany.';
          else if (variant.inventory_management && variant.inventory_policy === 'deny' && counts.get(variant.id) > variant.inventory_quantity) message = 'Za mało sztuk tego wariantu dla wybranego zestawu.';
          const status = rows[index].querySelector('[data-bundle-status]');
          if (status) { status.textContent = message; status.hidden = !message; }
          if (message) available = false;
        });
        const valid = variants.every(Boolean);
        const total = valid ? variants.reduce((sum, variant) => sum + Number(variant.price), 0) : null;
        card.querySelector('[data-bundle-total]').textContent = total === null ? '—' : this.money(total, state.product.currency);
        if (active) activeBundle = { count: activeCount, variants, available, total, code: card.dataset.discountCode?.trim() || '', items: [...counts].map(([id, quantity]) => ({ id, quantity })) };
      });
      state.bundle = activeBundle;
      if (!activeBundle) return;
      const total = picker.querySelector('[data-bundle-selected-total]');
      if (total) total.textContent = activeBundle.total === null ? '—' : this.money(activeBundle.total, state.product.currency);
      const discountNote = picker.querySelector('[data-bundle-discount-note]');
      if (discountNote) discountNote.hidden = !activeBundle.code;
      const addButton = state.form.querySelector('[name="add"]');
      const stickyButton = root.querySelector('[data-sticky-buy]');
      const label = state.busy ? 'Dodawanie…' : activeBundle.available ? state.product.labels.add : 'Wybierz dostępne warianty';
      if (addButton) { addButton.disabled = !activeBundle.available || state.busy; const text = addButton.querySelector('[data-add-label]'); if (text) text.textContent = label; }
      if (stickyButton) { stickyButton.disabled = !activeBundle.available || state.busy; stickyButton.textContent = label; }
      const stickyPrice = root.querySelector('.sticky-atc__text small');
      if (stickyPrice) stickyPrice.textContent = activeBundle.total === null ? '' : `${activeBundle.count} ${activeBundle.count === 1 ? 'sztuka' : 'sztuki'} · ${this.money(activeBundle.total, state.product.currency)}`;
    }

    async applyBundleCode(code) {
      const response = await fetch(this.cartUrl() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Nie udało się odczytać rabatów w koszyku.');
      const cart = await response.json();
      const hasDiscount = Number(cart.total_discount) > 0 || (cart.discount_codes || []).length > 0 || (cart.cart_level_discount_applications || []).length > 0 || (cart.items || []).some((item) => (item.line_level_discount_allocations || []).length > 0 || (item.discounts || []).length > 0);
      if (hasDiscount) return { cart, notice: `W koszyku jest już rabat — zachowaliśmy go. Kod zestawu ${code} możesz sprawdzić podczas płatności.` };
      const update = await fetch(this.cartUrl() + '/update.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) });
      const updatedCart = await update.json();
      if (!update.ok) return { cart, notice: `Produkty dodano. Kod ${code} nie został zastosowany; możesz sprawdzić go podczas płatności.` };
      const confirmed = Number(updatedCart.total_discount) > Number(cart.total_discount || 0) || (updatedCart.discount_codes || []).some((entry) => String(entry.code).toLowerCase() === code.toLowerCase() && entry.applicable === true);
      return { cart: updatedCart, notice: confirmed ? `Rabat zestawu został uwzględniony w cenie koszyka.` : `Produkty dodano. Sprawdź cenę koszyka — kod ${code} nie został potwierdzony jako aktywny.` };
    }

    showMedia(root, mediaId, imageUrl, alt) {
      const media = [...root.querySelectorAll('[data-product-media]')];
      const target = media.find((item) => item.dataset.mediaId === mediaId);
      if (target) {
        media.forEach((item) => {
          item.hidden = item !== target;
          if (item !== target) {
            item.querySelectorAll('video').forEach((video) => video.pause());
            item.querySelectorAll('iframe').forEach((frame) => {
              if (frame.dataset.playing === 'true') frame.src = frame.src;
            });
          } else item.querySelectorAll('iframe').forEach((frame) => { frame.dataset.playing = 'true'; });
        });
      } else if (imageUrl) {
        const image = root.querySelector('[data-variant-image]');
        if (image) { image.src = imageUrl; image.removeAttribute('srcset'); image.alt = alt || image.alt; image.dataset.mediaId = mediaId; }
      }
      root.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
        const active = thumb.dataset.mediaId === mediaId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    }

    updateCountdowns(scope = document) {
      scope.querySelectorAll('[data-promo-countdown]').forEach((node) => {
        const remaining = Date.parse(node.dataset.end || '') - Date.now();
        const root = node.closest('[data-product-root]');
        const visible = root?.dataset.onSale === 'true' && Number.isFinite(remaining) && remaining > 0;
        node.hidden = !visible;
        if (!visible) return;
        const seconds = Math.ceil(remaining / 1000);
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor((seconds % 86400) / 3600), minutes: Math.floor((seconds % 3600) / 60), seconds: seconds % 60 };
        Object.entries(values).forEach(([part, value]) => { const target = node.querySelector(`[data-countdown-${part}]`); if (target) target.textContent = String(value).padStart(2, '0'); });
      });
    }

    updateSticky() {
      document.querySelectorAll('[data-product-root]').forEach((root) => {
        const sticky = root.querySelector('[data-sticky-atc]');
        const main = root.querySelector('[data-main-atc]');
        if (!sticky || !main) return;
        const rect = main.getBoundingClientRect();
        const visible = rect.bottom < 0 || (window.innerWidth <= 760 && rect.top > window.innerHeight - 80);
        sticky.classList.toggle('is-visible', visible);
        sticky.inert = !visible;
        sticky.setAttribute('aria-hidden', String(!visible));
      });
    }

    onClick(event) {
      const target = event.target.closest('button, a, [data-mobile-menu]');
      if (!target) return;
      if (target.matches('[data-menu-open]')) return this.setMenu(true);
      if (target.matches('[data-size-chart-open]')) {
        const dialog = target.closest('[data-product-root]')?.querySelector('[data-size-chart]');
        if (dialog && !dialog.open) { dialog.showModal(); document.body.classList.add('pp-dialog-open'); }
        return;
      }
      if (target.matches('[data-size-chart-close]')) { target.closest('[data-size-chart]')?.close(); return; }
      if (target.matches('[data-menu-close]') || target.matches('[data-mobile-menu]') && event.target === target) return this.setMenu(false);
      if (target.matches('[data-search-toggle]')) {
        const panel = document.querySelector('[data-search-panel]');
        const visible = panel?.classList.toggle('is-open');
        target.setAttribute('aria-expanded', String(Boolean(visible)));
        if (visible) panel.querySelector('input')?.focus();
      }
      if (target.matches('[data-faq-button]')) {
        const item = target.closest('.faq-item');
        if (item) target.setAttribute('aria-expanded', String(item.classList.toggle('is-open')));
      }
      if (target.matches('[data-cart-drawer-open]') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) { event.preventDefault(); return this.openCart(); }
      if (target.matches('[data-cart-drawer-close]')) return this.closeCart();
      if (target.matches('[data-step]')) {
        const input = target.closest('[data-quantity]')?.querySelector('input');
        if (!input) return;
        const step = Number(input.step) || 1;
        const min = input.min === '' ? 1 : Number(input.min);
        const max = input.max ? Number(input.max) : Infinity;
        input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(target.dataset.step) * step));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (target.matches('[data-media-thumb]')) {
        const root = target.closest('[data-product-root]');
        if (root) this.showMedia(root, target.dataset.mediaId, target.dataset.imageUrl, target.dataset.imageAlt);
      }
      if (target.matches('[data-sticky-buy]')) target.closest('[data-product-root]')?.querySelector('[data-main-atc]')?.click();
      if (target.matches('[data-cart-step], [data-cart-remove]')) {
        const item = target.closest('[data-cart-key]');
        const input = item?.querySelector('[data-cart-quantity]');
        if (!item || !input) return;
        const quantity = target.matches('[data-cart-remove]') ? 0 : Math.max(0, Number(input.value) + Number(target.dataset.cartStep));
        this.changeCart(item.dataset.cartKey, quantity);
      }
    }

    onChange(event) {
      const target = event.target;
      if (target.matches('[data-option-select]')) {
        const root = target.closest('[data-product-root]');
        this.syncBundleFirstRow(root, false);
        this.updateVariant(root, true);
      }
      if (target.matches('[data-bundle-choice]')) {
        const root = target.closest('[data-product-root]');
        this.syncBundleFirstRow(root, false);
        this.updateVariant(root, false);
      }
      if (target.matches('[data-bundle-option]')) {
        const root = target.closest('[data-product-root]');
        const row = target.closest('[data-bundle-row]');
        const firstRow = target.closest('[data-bundle-card]').querySelector('[data-bundle-row]');
        if (row === firstRow) { this.syncBundleFirstRow(root, true); this.updateVariant(root, true); }
        else this.updateBundles(root);
      }
      if (target.matches('[data-sort-select]')) target.form?.requestSubmit();
      if (target.matches('[data-cart-quantity]')) {
        const item = target.closest('[data-cart-key]');
        if (item && target.checkValidity()) this.changeCart(item.dataset.cartKey, Number(target.value));
        else target.reportValidity();
      }
    }

    async onSubmit(event) {
      const form = event.target;
      if (!form.matches('[data-product-form]') || form.dataset.ajax === 'false') return;
      const root = form.closest('[data-product-root]');
      const state = this.products.get(root);
      if (!state) return;
      event.preventDefault();
      if (state.busy || !state.variant?.available || state.bundle?.available === false || !form.reportValidity()) return;
      state.busy = true;
      this.productError(root, '');
      this.updateVariant(root, false);
      let added = false;
      try {
        const payload = state.bundle ? JSON.stringify({ items: state.bundle.items }) : new FormData(form);
        const headers = state.bundle ? { Accept: 'application/json', 'Content-Type': 'application/json' } : { Accept: 'application/json' };
        const response = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers, body: payload });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Nie udało się dodać produktu. Sprawdź dostępność wybranego wariantu.');
        added = true;
        let cart = null;
        let notice = '';
        if (state.bundle?.code) {
          try { const discounted = await this.applyBundleCode(state.bundle.code); cart = discounted.cart; notice = discounted.notice; }
          catch (_) { notice = 'Produkty dodano. Nie udało się potwierdzić rabatu zestawu. Sprawdź cenę w koszyku przed płatnością.'; }
        }
        if (form.dataset.redirect === 'cart') { window.location.assign(this.cartUrl()); return; }
        await this.openCart(cart, true, notice);
      } catch (error) {
        // Never repeat /cart/add: even a lost response may already have added it.
        this.productError(root, added ? 'Produkt dodano. Otwórz koszyk, aby dokończyć zakup.' : (error.message === 'Failed to fetch' ? 'Nie udało się potwierdzić dodania. Sprawdź koszyk przed ponowną próbą.' : error.message));
      } finally {
        state.busy = false;
        this.updateVariant(root, false);
      }
    }

    productError(root, message) {
      const error = root.querySelector('[data-product-error]');
      if (error) { error.textContent = message; error.hidden = !message; }
    }
    setMenu(visible) {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const wasOpen = menu.classList.contains('is-open');
      menu.classList.toggle('is-open', visible);
      menu.setAttribute('aria-hidden', String(!visible));
      document.body.classList.toggle('menu-open', visible);
      document.querySelector('[data-menu-open]')?.setAttribute('aria-expanded', String(visible));
      if (visible) menu.querySelector('[data-menu-close]')?.focus();
      else if (wasOpen) document.querySelector('[data-menu-open]')?.focus();
    }

    async openCart(cart = null, justAdded = false, notice = '') {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) { window.location.assign(this.cartUrl()); return; }
      if (!drawer.classList.contains('is-open')) this.lastFocused = document.activeElement;
      this.setMenu(false);
      drawer.inert = false;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      drawer.querySelector('.cart-drawer__close')?.focus();
      drawer.querySelector('[data-cart-drawer-error]').hidden = true;
      drawer.querySelector('[data-cart-drawer-fallback]').hidden = true;
      drawer.querySelector('[data-cart-drawer-loading]').hidden = false;
      drawer.querySelector('[data-cart-drawer-empty]').hidden = true;
      drawer.querySelector('[data-cart-drawer-content]').hidden = true;
      try {
        if (!cart) { const response = await fetch(this.cartUrl() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }); if (!response.ok) throw new Error(); cart = await response.json(); }
        this.renderCart(cart);
        this.cartNotice(notice);
      } catch (_) {
        const error = drawer.querySelector('[data-cart-drawer-error]');
        error.textContent = justAdded ? 'Produkt dodano do koszyka. Nie udało się odświeżyć podglądu — przejdź do pełnego koszyka.' : 'Nie udało się odświeżyć koszyka. Możesz otworzyć jego pełną wersję.';
        error.hidden = false;
        drawer.querySelector('[data-cart-drawer-fallback]').hidden = false;
      } finally { drawer.querySelector('[data-cart-drawer-loading]').hidden = true; }
    }

    cartNotice(message) {
      const content = document.querySelector('[data-cart-drawer-content]');
      if (!content) return;
      let node = content.querySelector('[data-cart-discount-notice]');
      if (!node) { node = document.createElement('p'); node.className = 'pp-cart-notice'; node.dataset.cartDiscountNotice = ''; node.setAttribute('role', 'status'); content.prepend(node); }
      node.textContent = message;
      node.hidden = !message;
    }

    closeCart() {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      document.body.classList.remove('cart-drawer-open');
      if (this.lastFocused?.isConnected) this.lastFocused.focus();
    }

    buildCartItem(item, currency) {
      const element = (tag, className, text) => { const node = document.createElement(tag); node.className = className; if (text != null) node.textContent = text; return node; };
      const article = element('article', 'cart-drawer__item');
      article.dataset.cartKey = item.key;
      const media = element('a', 'cart-drawer__item-media'); media.href = item.url || this.cartUrl();
      const imageUrl = item.featured_image?.url || item.image;
      if (imageUrl) { const image = document.createElement('img'); image.src = imageUrl; image.alt = item.featured_image?.alt || item.product_title || ''; image.width = 180; image.height = 180; image.loading = 'lazy'; media.append(image); }
      const details = element('div', 'cart-drawer__item-details');
      const title = element('a', 'cart-drawer__item-title', item.product_title || item.title); title.href = item.url || this.cartUrl(); details.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') details.append(element('small', '', item.variant_title));
      const row = element('div', 'cart-drawer__item-row');
      const quantity = element('div', 'cart-drawer__quantity');
      const minus = element('button', '', '−'); minus.type = 'button'; minus.dataset.cartStep = '-1'; minus.setAttribute('aria-label', `Zmniejsz ilość: ${item.product_title}`);
      const input = document.createElement('input'); input.type = 'number'; input.min = '0'; input.step = '1'; input.value = item.quantity; input.dataset.cartQuantity = ''; input.setAttribute('aria-label', `Ilość: ${item.product_title}`);
      const plus = element('button', '', '+'); plus.type = 'button'; plus.dataset.cartStep = '1'; plus.setAttribute('aria-label', `Zwiększ ilość: ${item.product_title}`);
      quantity.append(minus, input, plus);
      row.append(quantity, element('strong', '', this.money(item.final_line_price ?? item.line_price, currency)));
      const remove = element('button', 'cart-drawer__remove', 'Usuń'); remove.type = 'button'; remove.dataset.cartRemove = ''; remove.setAttribute('aria-label', `Usuń: ${item.product_title}`);
      details.append(row, remove); article.append(media, details); return article;
    }

    renderCart(cart) {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;
      this.lastCart = cart;
      const hasItems = Number(cart.item_count) > 0;
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.hidden = !hasItems; });
      drawer.querySelector('[data-cart-drawer-empty]').hidden = hasItems;
      drawer.querySelector('[data-cart-drawer-content]').hidden = !hasItems;
      const container = drawer.querySelector('[data-cart-drawer-items]');
      container.replaceChildren(...cart.items.map((item) => this.buildCartItem(item, cart.currency || 'PLN')));
      drawer.querySelector('[data-cart-drawer-total]').textContent = this.money(cart.total_price, cart.currency || 'PLN');
      const shipping = drawer.querySelector('[data-cart-shipping]');
      const threshold = Number(drawer.dataset.freeShippingThreshold);
      if (shipping) {
        shipping.hidden = !hasItems || !(threshold > 0) || cart.currency !== drawer.dataset.shopCurrency;
        if (!shipping.hidden) {
          const remaining = Math.max(0, threshold - cart.total_price);
          shipping.querySelector('[data-cart-shipping-label]').textContent = remaining ? `Do darmowej dostawy brakuje ${this.money(remaining, cart.currency)}.` : 'Osiągnięto próg darmowej dostawy.';
          shipping.querySelector('progress').value = Math.min(100, cart.total_price / threshold * 100);
        }
      }
    }

    async changeCart(key, quantity) {
      if (this.cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
      this.cartBusy = true;
      const drawer = document.querySelector('[data-cart-drawer]');
      const error = drawer.querySelector('[data-cart-drawer-error]');
      const focused = document.activeElement;
      const focusControl = focused?.matches('[data-cart-quantity]') ? '[data-cart-quantity]' : focused?.matches('[data-cart-step]') ? `[data-cart-step="${focused.dataset.cartStep}"]` : null;
      error.hidden = true;
      drawer.querySelectorAll('[data-cart-drawer-content] button, [data-cart-quantity]').forEach((node) => { node.disabled = true; });
      drawer.querySelector('[data-cart-drawer-items]').setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.cartUrl() + '/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Nie udało się zmienić ilości. Sprawdź dostępność produktu.');
        this.renderCart(result);
      } catch (failure) {
        if (this.lastCart) this.renderCart(this.lastCart);
        error.textContent = failure.message || 'Nie udało się zaktualizować koszyka.';
        error.hidden = false;
      }
      finally {
        this.cartBusy = false;
        drawer.querySelectorAll('[data-cart-drawer-content] button, [data-cart-quantity]').forEach((node) => { node.disabled = false; });
        drawer.querySelector('[data-cart-drawer-items]').removeAttribute('aria-busy');
        if (focusControl) [...drawer.querySelectorAll('[data-cart-key]')].find((item) => item.dataset.cartKey === key)?.querySelector(focusControl)?.focus();
      }
    }

    onKeydown(event) {
      if (document.querySelector('[data-size-chart][open]')) return;
      const drawer = document.querySelector('[data-cart-drawer].is-open');
      if (event.key === 'Escape') { if (drawer) this.closeCart(); this.setMenu(false); }
      const modal = drawer || document.querySelector('[data-mobile-menu].is-open');
      if (event.key !== 'Tab' || !modal) return;
      const elements = [...modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]')].filter((element) => element.getClientRects().length && !element.closest('[hidden]') && element.tabIndex >= 0);
      const first = elements[0]; const last = elements[elements.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  }
  const start = () => { if (!window.pouchTheme) window.pouchTheme = new PouchTheme(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
